import React, { useState } from "react";
import { MdClose } from "react-icons/md";
import BBMainLayout from "../../../components/Seo/whitelabel/bybest/BBMainLayout";
import useSeoData from "../../../services/hooks/use-seo";
import "./index.css";
import { useLocalStorage } from "../../../services/hooks/use-localstorage";
import { t } from "i18next";
import { getBrandTranslation } from "../brands/brands";

const getWishlistText = (label = "") => t(`bybest.wishlist.${label}`);

const ByBestWishList = () => {
  const { pageSEO } = useSeoData();
  const [productList, setProductList] = useLocalStorage("wishlist", [
    {
      id: 10,
      title: "LOFT ROUND SUGAR CANISTER WITH BAMBOOO LID Q.B",
      category: "LOFT ROUND SUGAR CANISTER WITH BAMBOOO LID Q.B",
      img1: "https://admin.bybest.shop/storage/products/62447fc3e1f44_KLE20QB101-01 frusta.jpg",
      img2: "https://admin.bybest.shop/storage/products/62447fc3ecd4b_KLE20QB101-03.jpg",
      no: "KLE20QB101",
      price: 3599,
      discount: "60%",
      sale_price: 1440,
    },
  ]);

  const [showMessage, setShowMessage] = useState(null);

  const onRemoveItem = (product, type = null) => {
    setProductList(productList?.filter((item) => item.id !== product.id));
    setShowMessage(type);
  };

  return (
    <BBMainLayout clientKey="bybest" seo={pageSEO}>
      <div className="w-full flex flex-col justify-center items-center bg-white overflow-hidden">
        {showMessage !== null && (
          <div className="success-message w-full">
            <span>{getWishlistText(showMessage)}</span>
          </div>
        )}
        <div className="w-full flex justify-center items-center bg-[#F2F2F2] breadcumb">
          {getBrandTranslation("breadcrumb")} {getWishlistText("wishlist")}
        </div>

        <div className="w-full max-w-screen-main mb-5 px-5 md:px-0">
          <div
            className={`mt-5 w-full px-[15px] py-[10px] rounded-[5px] text-[14px] ${
              productList.length > 0
                ? "bg-black text-white uppercase"
                : "bg-[#d2d2d2] text-black"
            } `}
          >
            {productList.length > 0
              ? getBrandTranslation("products")
              : getBrandTranslation("no_products")}
          </div>
          <div className="mt-3 w-full">
            {productList.map((product) => (
              <div className="relative w-full mt-4 pb-5 grid grid-cols-3 md:flex md:justify-center items-center border-b border-b-[#d2d2d2] !bg-white">
                <div className="h-[220px] w-[210px]image-details">
                  <img
                    src={product.img1}
                    width={210}
                    height={220}
                    className="object-overlay border-[1px] border-[#e0e0e0] rounded-[6px]"
                    alt=""
                  />
                </div>
                <div className="col-span-2 h-[220px] ml-4 flex flex-col justify-between items-start w-full overflow-hidden">
                  <div className="flex justify-between w-full pr-2 gap-2 overflow-hidden">
                    <div className="flex flex-col overflow-hidden">
                      <span className="product-title truncate">
                        {product.title}
                      </span>
                      <span className="product-description truncate">
                        {product.category}
                      </span>
                    </div>

                    <div
                      className="w-[38px] h-[38px] rounded border border-[#222] flex justify-center items-center cursor-pointer mr-2 md:mr-0"
                      onClick={() => onRemoveItem(product, "removeItem")}
                    >
                      <MdClose color="#222" size={20} />
                    </div>
                  </div>

                  <div className="w-full grid xl:flex justify-between items-end">
                    <p className="text-[13px] text-black font-medium">
                      {getBrandTranslation("price")}:{" "}
                      <b>LEK {product.sale_price ?? "150"}</b>
                    </p>
                    <div
                      className="flex lg:justify-end"
                      onClick={() => setShowMessage("addedCart")}
                    >
                      <button className="w-full mt-2 rounded-[5px] bg-black h-[42px] font-bold text-[14px] text-white uppercase">
                        {getBrandTranslation("addtobag")}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </BBMainLayout>
  );
};

export default ByBestWishList;
